export const BreakpointSmDefault = 360;
export const BreakpointSmMin = 0;
export const BreakpointSmMax = 767;
export const BreakpointMdDefault = 768;
export const BreakpointMdMin = 768;
export const BreakpointMdMax = 1023;
export const BreakpointLgDefault = 1280;
export const BreakpointLgMin = 1024;
export const BreakpointLgMax = 1439;
export const BreakpointXlDefault = 1440;
export const BreakpointXlMin = 1440;
export const BreakpointXlMax = 1920;
export const FontSize10 = "0.7142857142857143rem";
export const FontSize12 = "0.8571428571428571rem";
export const FontSize14 = "1rem";
export const FontSize16 = "1.1428571428571428rem";
export const FontSize18 = "1.2857142857142858rem";
export const FontSize20 = "1.4285714285714286rem";
export const FontSize24 = "1.7142857142857142rem";
export const FontSize28 = "2rem";
export const FontSize32 = "2.2857142857142856rem";
export const FontSize40 = "2.857142857142857rem";
export const FontSize48 = "3.4285714285714284rem";
export const FontSize56 = "4rem";
export const FontSize64 = "4.571428571428571rem";
export const FontSize80 = "5.714285714285714rem";
export const FontSize96 = "6.857142857142857rem";
export const FontWeightThin = 100;
export const FontWeightExtraLight = 200;
export const FontWeightLight = 300;
export const FontWeightRegular = 400;
export const FontWeightMedium = 500;
export const FontWeightSemibold = 600;
export const FontWeightBold = 700;
export const FontWeightExtraBold = 800;
export const FontWeightBlack = 900;
export const FontLineHeightNone = 1;
export const FontLineHeightTight = 1.2;
export const FontLineHeightNormal = 1.5;
export const SizeSpacing2 = "2px";
export const SizeSpacing4 = "4px";
export const SizeSpacing6 = "6px";
export const SizeSpacing8 = "8px";
export const SizeSpacing12 = "12px";
export const SizeSpacing16 = "16px";
export const SizeSpacing20 = "20px";
export const SizeSpacing24 = "24px";
export const SizeSpacing28 = "28px";
export const SizeSpacing32 = "32px";
export const SizeSpacing40 = "40px";
export const SizeSpacing48 = "48px";
export const SizeSpacing56 = "56px";
export const SizeSpacing64 = "64px";
export const SizeSpacing72 = "72px";
export const SizeSpacing80 = "80px";
export const SizeSpacing88 = "88px";
export const SizeSpacing96 = "96px";
export const SizeSpacing104 = "104px";
export const SizeSpacing112 = "112px";
export const SizeSpacing120 = "120px";
export const SizeRadius4 = "4px";
export const SizeRadius8 = "8px";
export const SizeRadius16 = "16px";
export const SizeRadiusNone = "0px";
export const SizeRadiusFull = "100vw";
export const SizeRadiusStrokeDefault = "1px";
export const SizeRadiusStrokeFocus = "2px";
export const SizeIconXSmall = "16px";
export const SizeIconSmall = "20px";
export const SizeIconMedium = "24px";
export const SizeIconLarge = "32px";
export const SizeIconXLarge = "48px";
export const SizeIconXxLarge = "64px";
export const SizeRatingIconSmall = "12px";
export const SizeRatingIconMedium = "16px";
export const SizeRatingIconLarge = "24px";
